import React, {useEffect, useState} from 'react';
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    getDecodedParamsFromUl,
    getDefStr,
    getEncodedUrl,
    getJsonValue,
    isBoolTrue,
    isJsonValueTrue,
    isValueBool,
    setTabTitle
} from "../../../../common/fusion-ui/utils/ReactUtils";
import {Keys, ModuleRouteUrls, Modules, ReqUrls} from "../../../config/AppConfig";
import {getAllocatedModuleName, isModuleAllocated, printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {SimpleTabPane, TabLayout} from "../../../../common/fusion-ui";
import {CSPanel, DocPanel, ImagePanel, LinkPanel, PubPanel, RecentResPanel, VideoPanel} from 'app/index';
import {useReduxPersistSessionData} from "../../../hook/useReduxPersistSessionData";
import useScreenSize from "../../../../common/fusion-ui/hook/useScreenSize";
import {CssVariant, Messages} from "../../../../common/fusion-ui/config/FusionConfig";
import {useConfig} from "../../../context/ConfigProvider";
import {AnimationType, FramerAnimator} from "../../../../common/fusion-ui/animation/FramerAnimator";

/**
 * Tab-layout component that contains home Modules like: Publication, Resources, Documents etc.
 */
const HomeTabLayout = React.memo(({
                                      className = "",
                                      // defTab = Modules.RecentResources,
                                      defTab,
                                      style = {},
                                  }) => {
    const TAG = "HomeTabLayout";

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isScreenUpSm, isScreenXs, isScreenSm, isScreenMd} = useScreenSize();
    const {updateConfig} = useConfig();

    const animator = new FramerAnimator();

    const URL_PARAM_KEY = Keys.urlParam_Tab;
    const URL_PARAM_VALUE_KEY = 'paramValue';

    const TABS = {
        recentResources: {
            name: Modules.RecentResources,
            icon: 'fa fa-history',
            url: ModuleRouteUrls[Modules.RecentResources],
            [URL_PARAM_VALUE_KEY]: 'rec-res',
        },
        publication: {
            name: Modules.Publication,
            icon: 'fa fa-bullhorn',
            url: ModuleRouteUrls[Modules.Publication],
            [URL_PARAM_VALUE_KEY]: 'pub',
        },
        document: {
            name: Modules.Documents,
            icon: 'fa fa-file-text',
            url: ModuleRouteUrls[Modules.Documents],
            [URL_PARAM_VALUE_KEY]: 'docx',
        },
        caseStudy: {
            name: Modules.CaseStudy,
            icon: 'fa fa-chain-broken',
            url: ModuleRouteUrls[Modules.CaseStudy],
            [URL_PARAM_VALUE_KEY]: 'cs',
        },
        video: {
            name: Modules.Videos,
            icon: 'fa fa-video-camera',
            url: ModuleRouteUrls[Modules.Videos],
            [URL_PARAM_VALUE_KEY]: 'videos',
        },
        image: {
            name: Modules.Images,
            icon: 'fa fa-picture-o',
            url: ModuleRouteUrls[Modules.Images],
            [URL_PARAM_VALUE_KEY]: 'images',
        },
        usefulLink: {
            name: Modules.UsefulLinks,
            icon: 'fa fa-link',
            url: ModuleRouteUrls[Modules.UsefulLinks],
            [URL_PARAM_VALUE_KEY]: 'ul',
        },

    };
    const DEF_TAB_NAME = TABS.recentResources.name;
    const DEF_TAB_INDEX = 0;

    const Fields = {
        defTabName: Keys.store_Dash_HomeTab_TabLayout_SelectedTabName,
        defTabIndex: Keys.store_Dash_HomeTab_TabLayout_SelectedTabIndex,
        isDataFound: 'isDataFound',
    };
    const [defTabName, setDefTabName] = useState(DEF_TAB_NAME);
    const [defTabIndex, setDefTabIndex] = useState(DEF_TAB_INDEX);

    const [fieldsData, setFieldsData] = useState({});
    const [allModulesData, setAllModulesData] = useState({});
    const [allModulesLoadingData, setAllModulesLoadingData] = useState({});

    const {
        sessionData,
        updateSessionStoreFieldValue, getSessionStoreFieldValue
    } = useReduxPersistSessionData({
        keys: [Fields.defTabName, Fields.defTabIndex,],
    });

    useEffect(() => {
        // updateSessionStoreFieldValue(Fields.defTabName, getDefTabName(defTab));
        // updateSessionStoreFieldValue(Fields.defTabIndex, getDefTabIndex(defTab));
        const selectedTab = getDefStr(getDefStr(getJsonValue(sessionData, Fields.defTabName), defTab), DEF_TAB_NAME);
        // log('useEffect.selectedTab:', selectedTab, 'defTab:', defTab);
        if (checkNullStr(selectedTab)) {
            setDefTabName(selectedTab);
            setDefTabIndex(Object.values(TABS).findIndex(item => item.name == selectedTab) || DEF_TAB_INDEX);
            fetchSelectedTabData(selectedTab, true, true);
        }
    }, [sessionData, defTab]);
    useEffect(() => {
        // fetchSelectedTabData(getJsonValue(sessionData, Fields.defTabName));
        // fetchSelectedTabData(getDefTabName(defTab));
        // updateSessionFieldValue('MMMMMMMMM', 'yy');
        // log('useEffect.sessionData:', sessionData);
        // log('useEffect.sessionData.tabName:', tabName);
    }, [sessionData]);
    useEffect(() => {
        // log('useEffect.allModulesData:', allModulesData);
        // log('useEffect.allModulesLoadingData:', allModulesLoadingData);
    }, [allModulesData, allModulesLoadingData]);
    // useEffect(() => {
    // log('useEffect.sessionData:', sessionData);
    // }, [sessionData]);

    return (<>
        <div className={`w-100 m-0 p-0 mt-1 ${className}`}>
            <div
                className={`w-100 m-0 p-0 ${isScreenUpSm ? '' : 'rounded-5'}`}
                style={{backgroundColor: isScreenUpSm ? 'transparent' : theme.primary10Opaque}}>
                {isScreenUpSm
                    ? <div className={''}>
                        {animator.setAnimationType(AnimationType.FADE_IN).setDelay(300).setDuration(200).render(
                            <SimpleTabPane
                                tabClassName={`rounded-5 fs-sm-md border-1 border-theme border-solid text-white-hover text-white-active`}
                                iconClassName={''}
                                tabsWrapperClassName={''}
                                variant={'theme'}
                                reverseVariant={'light'}
                                tabsAt={'start'}
                                height={isScreenUpSm ? '100%' : '80vh'}
                                defTabIndex={getDefTabIndex(getSessionFieldValue(Fields.defTabName))}
                                contentClassName={'mt-n2x'}
                                tabTextAt={'start'}
                                retainContentInDomOnTabChange={true}
                                pushUrlParam={false}
                                urlParamKey={URL_PARAM_KEY}
                                urlParamValueKey={URL_PARAM_VALUE_KEY}
                                onChange={(e, index, tabName) => {
                                    // log('homeTabPane.tabName:', tabName, 'index:', index);
                                    updateSessionFieldValue(Fields.defTabName, tabName);
                                    updateSessionFieldValue(Fields.defTabIndex, index);
                                    fetchSelectedTabData(tabName, false, true);
                                }}>
                                {renderTabs()}
                            </SimpleTabPane>
                        )}
                    </div>
                    : <div className={''}>
                        {animator.setAnimationType(AnimationType.FADE_IN).setDelay(300).setDuration(200).render(
                            <TabLayout
                                className={'w-100'}
                                // tabsWidth={'13'} - change made by Vandit (25/10/2024) set width to auto so side menu can adjust itself according to links in it
                                tabsWidth={'auto'}
                                contentWidth={87}
                                contentWrapperClass={'position-relative'}
                                contentClassName={'home-tab-layout-content xps-2'}
                                tabsWrapperClassName={'rounded-5'}
                                tabClassName={`py-3 px-2 fs-sm-md rounded-5 fw-bold`}
                                iconClassName={'me-2'}
                                variant={'theme'}
                                reverseVariant={'light'}
                                tabsBg={theme.primary10}
                                height={isScreenUpSm ? '100%' : '68vh'}
                                defTabIndex={getDefTabIndex(getSessionFieldValue(Fields.defTabName))}
                                tabTextAt={'start'}
                                tabTextVertAt={'start'}
                                showDivider={false}
                                retainContentInDomOnTabChange={true}
                                pushUrlParam={false}
                                urlParamKey={URL_PARAM_KEY}
                                urlParamValueKey={URL_PARAM_VALUE_KEY}
                                onChange={(e, index, tabName) => {
                                    // log('homeTabLayout.tabName:', tabName, 'index:', index);
                                    updateSessionFieldValue(Fields.defTabName, tabName);
                                    updateSessionFieldValue(Fields.defTabIndex, index);
                                    fetchSelectedTabData(tabName, false, true);
                                }}>{renderTabs()}</TabLayout>
                        )}
                    </div>}
            </div>
        </div>
    </>)

    //======================UI Functions start=====================
    function renderTabs() {
        return [
            isModuleAllocated(TABS.recentResources.name) && {
                title: TABS.recentResources.name,
                renderTitle: getAllocatedModuleName(TABS.recentResources.name),
                icon: TABS.recentResources.icon,
                url: TABS.recentResources.url,
                [URL_PARAM_VALUE_KEY]: TABS.recentResources[URL_PARAM_VALUE_KEY],
                children: <RecentResPanel
                    panelData={getTabModuleData(TABS.recentResources.name)}
                    loadingStatus={getTabModuleLoadingData(TABS.recentResources.name)}
                />,
            },
            isModuleAllocated(TABS.publication.name) && {
                title: TABS.publication.name,
                renderTitle: getAllocatedModuleName(TABS.publication.name),
                icon: TABS.publication.icon,
                url: TABS.publication.url,
                [URL_PARAM_VALUE_KEY]: TABS.publication[URL_PARAM_VALUE_KEY],
                children: <PubPanel
                    recordList={getTabModuleData(TABS.publication.name)}
                    loadingStatus={getTabModuleLoadingData(TABS.publication.name)}
                />,
            },
            isModuleAllocated(TABS.document.name) && {
                title: TABS.document.name,
                renderTitle: getAllocatedModuleName(TABS.document.name),
                icon: TABS.document.icon,
                url: TABS.document.url,
                [URL_PARAM_VALUE_KEY]: TABS.document[URL_PARAM_VALUE_KEY],
                children: <DocPanel
                    recordList={getTabModuleData(TABS.document.name)}
                    loadingStatus={getTabModuleLoadingData(TABS.document.name)}
                />,
            },
            isModuleAllocated(TABS.caseStudy.name) && {
                title: TABS.caseStudy.name,
                renderTitle: getAllocatedModuleName(TABS.caseStudy.name),
                icon: TABS.caseStudy.icon,
                url: TABS.caseStudy.url,
                [URL_PARAM_VALUE_KEY]: TABS.caseStudy[URL_PARAM_VALUE_KEY],
                children: <CSPanel
                    recordList={getTabModuleData(TABS.caseStudy.name)}
                    loadingStatus={getTabModuleLoadingData(TABS.caseStudy.name)}
                />,
            },
            isModuleAllocated(TABS.video.name) && {
                title: TABS.video.name,
                renderTitle: getAllocatedModuleName(TABS.video.name),
                icon: TABS.video.icon,
                url: TABS.video.url,
                [URL_PARAM_VALUE_KEY]: TABS.video[URL_PARAM_VALUE_KEY],
                children: <VideoPanel
                    recordList={getTabModuleData(TABS.video.name)}
                    loadingStatus={getTabModuleLoadingData(TABS.video.name)}
                />,
            },
            isModuleAllocated(TABS.image.name) && {
                title: TABS.image.name,
                renderTitle: getAllocatedModuleName(TABS.image.name),
                icon: TABS.image.icon,
                url: TABS.image.url,
                [URL_PARAM_VALUE_KEY]: TABS.image[URL_PARAM_VALUE_KEY],
                children: <ImagePanel
                    recordList={getTabModuleData(TABS.image.name)}
                    loadingStatus={getTabModuleLoadingData(TABS.image.name)}
                />,
            },
            isModuleAllocated(TABS.usefulLink.name) && {
                title: TABS.usefulLink.name,
                renderTitle: getAllocatedModuleName(TABS.usefulLink.name),
                icon: TABS.usefulLink.icon,
                url: TABS.usefulLink.url,
                [URL_PARAM_VALUE_KEY]: TABS.usefulLink[URL_PARAM_VALUE_KEY],
                children: <LinkPanel
                    recordList={getTabModuleData(TABS.usefulLink.name)}
                    loadingStatus={getTabModuleLoadingData(TABS.usefulLink.name)}
                />,
            }
        ].filter(item => checkNullJson(item) && !isValueBool(item))
    }

    //======================UI Functions end=====================

    //======================Request Functions start=====================
    async function fetchSelectedTabData(selectedTab, hardPrevent = true, changeUrl = false) {
        const fun = 'fetchSelectedTabData:';
        // log(fun, 'selectedTab:', selectedTab, 'allModulesData:', allModulesData, 'allModulesLoadingData:', allModulesLoadingData);

        // if (!checkNullArr(getJsonValue(allModulesData, selectedTab)) && (!hardPrevent || (hardPrevent && !isFieldTrue(Fields.isDataFound)))) {
        if ((!checkNullArr(getJsonValue(allModulesData, selectedTab))) && (!hardPrevent || (hardPrevent && !isFieldTrue(Fields.isDataFound)))) {
            // if ((!isJsonValueTrue(getJsonValue(allModulesLoadingData, selectedTab), 'fetched')) && (!hardPrevent || (hardPrevent && !isFieldTrue(Fields.isDataFound)))) {
            // log(fun, 'selectedTab:', selectedTab, 'allModulesData:', allModulesData, 'allModulesLoadingData:', allModulesLoadingData);
            updateConfig(Keys.tracker_currPageModule, selectedTab);
            try {
                changeTabUrl(selectedTab);

                // log(fun, 'inside-selectedTab:', selectedTab, 'allModulesData:', allModulesData);

                switch (selectedTab) {
                    case TABS.recentResources.name:
                        await fetchModuleData(selectedTab, ReqUrls.recentRes__mainPage_fetch_recordList);
                        break;
                    case TABS.publication.name:
                        await fetchModuleData(selectedTab, ReqUrls.pub__mainPage_fetch_recordList);
                        // updateState(selectedTab, PubPanel_Data);
                        break;
                    case TABS.document.name:
                        await fetchModuleData(selectedTab, ReqUrls.doc__mainPage_fetch_recordList);
                        // updateState(selectedTab, DocPanel_Data);
                        break;
                    case TABS.caseStudy.name:
                        await fetchModuleData(selectedTab, ReqUrls.cs__mainPage_fetch_recordList);
                        // updateState(selectedTab, CsPanel_Data);
                        break;
                    case TABS.usefulLink.name:
                        await fetchModuleData(selectedTab, ReqUrls.link__mainPage_fetch_recordList);
                        // updateState(selectedTab, LinkPanel_Data);
                        break;
                    case TABS.image.name:
                        // updateState(selectedTab, ImgPanel_Data);
                        await fetchModuleData(selectedTab, ReqUrls.img__mainPage_fetch_recordList);
                        break;
                    case TABS.video.name:
                        // updateState(selectedTab, VidPanel_Data);
                        await fetchModuleData(selectedTab, ReqUrls.vid__mainPage_fetch_recordList);
                        break;
                    default:
                        toast('Invalid selection!', CssVariant.danger);
                        break;
                }
                updateField(Fields.isDataFound, true);
            } catch (error) {
                toast(Messages.fetchError, CssVariant.danger);
                logErr(fun, error);
                updateField(Fields.isDataFound, false);
                updateState(selectedTab, [], false, Messages.fetchError);
            }
        } else {
            changeTabUrl(selectedTab);
        }

        function updateState(moduleName, data, success = true, msg = '') {
            setAllModulesData(prevState => ({
                ...prevState, [moduleName]: data
            }));
            setAllModulesLoadingData(prevState => ({
                ...prevState,
                [selectedTab]: {
                    ...checkNullJson(prevState[selectedTab]) ? prevState[selectedTab] : {},
                    loaded: false, success: false, msg: ''
                }
            }));
            setAllModulesLoadingData(prevState => ({
                ...prevState,
                [moduleName]: {
                    ...checkNullJson(prevState[moduleName]) ? prevState[moduleName] : {},
                    loaded: true, success: success, msg: msg
                }
            }));
        }
    }

    async function fetchModuleData(moduleName, reqUrl) {
        const fun = 'fetchModuleData:';
        if (checkNullStr(moduleName)) {
            if (!isJsonValueTrue(allModulesLoadingData[moduleName], 'fetched')) {
                // log(fun, 'allModulesLoadingData:', allModulesLoadingData, 'allModulesData:', allModulesData);
                setAllModulesLoadingData(prevState => ({
                    ...prevState,
                    [moduleName]: {loaded: false, success: false, fetched: true, msg: ''}
                }));
                try {
                    await sendRequest({
                        reqUrl: reqUrl,
                        onFetched: ((fetchedData) => {
                            const success = isJsonValueTrue(fetchedData, 'success');
                            const message = getJsonValue(fetchedData, 'message');
                            // log(fun, 'moduleName:', moduleName, '\nfetchedData:', fetchedData, '\nrecordList:', recordList, '\nsuccess:', success, '\nmessage:', message, '\nallModulesData:', allModulesData, '\nallModulesLoadingData:', allModulesLoadingData);

                            if (success) {
                                // toast(message, CssVariant.success);

                                setAllModulesData(prevState => ({
                                    ...prevState,
                                    [moduleName]: getJsonValue(fetchedData, 'data', moduleName == TABS.recentResources.name ? {} : [])//recordList
                                }));

                                setAllModulesLoadingData(prevState => ({
                                    ...prevState,
                                    [moduleName]: {
                                        ...checkNullJson(prevState[moduleName]) ? prevState[moduleName] : {},
                                        loaded: true, success: success, msg: message
                                    }
                                }));
                            } else {
                                setAllModulesLoadingData(prevState => ({
                                    ...prevState,
                                    [moduleName]: {
                                        ...checkNullJson(prevState[moduleName]) ? prevState[moduleName] : {},
                                        loaded: true, success: success, msg: message
                                    }
                                }));

                                toast(message, CssVariant.danger);
                            }
                        }),
                        onError: ((error) => {
                            toast("Couldn't load data!", CssVariant.danger);
                            setAllModulesLoadingData(prevState => ({
                                ...prevState,
                                [moduleName]: {
                                    ...checkNullJson(prevState[moduleName]) ? prevState[moduleName] : {},
                                    loaded: true, success: false, msg: Messages.fetchError
                                }
                            }));
                            logErr(fun, error);
                        })
                    });
                } catch (error) {
                    toast("Couldn't load data!", CssVariant.danger);
                    setAllModulesLoadingData(prevState => ({
                        ...prevState,
                        [moduleName]: {
                            ...checkNullJson(prevState[moduleName]) ? prevState[moduleName] : {},
                            loaded: true, success: false, msg: Messages.fetchError
                        }
                    }));
                    logErr(fun, error);
                }
            }
        } else {
            toast('Module cannot be empty!', CssVariant.danger);
        }
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================
    function changeTabUrl(selectedTab) {
        const fun = 'changeTabUrl:';
        try {
            const browserUrl = window.location.href;
            const urlParams = getDecodedParamsFromUl(browserUrl);
            const newUrl = ModuleRouteUrls[selectedTab];
            const newUrl_encoded = checkNullJson(urlParams) ? getEncodedUrl(newUrl, urlParams) : newUrl;
            if (checkNullStr(newUrl_encoded)) {
                setTabTitle(getAllocatedModuleName(selectedTab));
                window.history.pushState({}, '', newUrl_encoded);
            }
        } catch (error) {
            logErr(fun, error);
        }
    }

    function getTabModuleData(tabName, defValue = []) {
        return getJsonValue(allModulesData, tabName, defValue);
    }

    function getTabModuleLoadingData(tabName, defValue = {}) {
        return getJsonValue(allModulesLoadingData, tabName, defValue);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateSessionFieldValue(field, value) {
        updateSessionStoreFieldValue(field, value);
    }

    function getSessionFieldValue(field, defValue) {
        return getSessionStoreFieldValue(field, defValue)
    }

    function getDefTabIndex(tabName) {
        try {
            const tabKeys = Object.keys(TABS);
            for (let i = 0; i < tabKeys.length; i++) {
                const tabKey = tabKeys[i];
                if (TABS[tabKey].name == tabName) {
                    // if (TABS[tabKey].name == getDefStr(tabName, getSessionFieldValue(Fields.defTabName))) {
                    return i;
                }
            }
        } catch (error) {
            logErr('getDefTabIndex:', error);
        }
        // return DEF_TAB_INDEX;
        return defTabIndex;
    }

    function getDefTabName(tabName) {
        try {
            const tabKeys = Object.keys(TABS);
            for (let i = 0; i < tabKeys.length; i++) {
                const tabKey = tabKeys[i];
                if (TABS[tabKey].name == tabName) {
                    // if (TABS[tabKey].name == getDefStr(tabName, getSessionFieldValue(Fields.defTabName))) {
                    return TABS[tabKey].name;
                }
            }
        } catch (error) {
            logErr('getDefTabName:', error);
        }
        // return DEF_TAB_NAME;
        return defTabName;
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default HomeTabLayout;
